import React, { useState } from 'react';
import { FlatList, View } from "react-native"
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { EventOrderStatProps, MarketProps } from '../../../store/types/mk_svc';
import { useSelector } from 'react-redux';
import { Icon } from 'react-native-elements';
import { SupportedMarketProps } from '../../../store/types/sr_svc';
import AthleteEventCard from './AthleteMarketCard';
import ExoticMarketCard from './ExoticMarketCard';
import EventMarketCard from './EventMarketCard';


type NonPrimaryMarketCardProps = {
    event_type:string,
    event_id:string,
    supported_markets:SupportedMarketProps[],
    navigation:any
    market_override?:string,
    onMarketDetails:() => void
}

const NonPrimaryMarketCard = ({event_type, event_id, onMarketDetails, navigation, supported_markets, market_override}:NonPrimaryMarketCardProps) => {
    const [ expanded, setExanded ] = useState(false);
    const [ market_select_visible, setMarketSelectVisible ] = useState(false);
    const [ active_market, setActiveMarket ] = useState<MarketProps|undefined>(undefined);

    let event_order_stats:EventOrderStatProps[] = useSelector((state:any) => state.market.order_stats[`${event_type}:${event_id}`] ?? [], (left, right) => left == right);
    if(market_override){
        event_order_stats = event_order_stats.filter(eos => eos.market_id == market_override)
    }
    let non_removed_supported_markets = supported_markets.filter(sm => !sm.removed);
    const non_primary_markets:MarketProps[] = useSelector((state:any) => state.market.markets.filter((m:MarketProps) => !m.primary_market && non_removed_supported_markets.map(sm => sm.market_id.toString()).includes(m.market_id)), (left, right) => left.length == right.length);
    let open_order_count = event_order_stats.reduce((a,b) => a + parseInt(b.open_order_count), 0)
    let open_order_amount = event_order_stats.reduce((a,b) => a + parseInt(b.open_order_amount), 0)

    let markets = non_primary_markets.filter(m => event_order_stats.map(s => s.market_id.toString()).includes(m.market_id))
    let visible_order_stats = event_order_stats.filter(s => s.market_id == active_market?.market_id);

    const handleExpand = () => {
        if(expanded){
            setActiveMarket(undefined)
            setExanded(false)
        } else {
            let prop_market = markets[0]
            setActiveMarket(prop_market)
            setExanded(true)
        }
    }


    const renderOrderStats = (data: { item:EventOrderStatProps, index:number }) => {
        if(!active_market){ return <></> }
        //if(data.item.side_type != 'athlete'){ return <></> }
        if(event_type != 'team'){ return <></> }
        switch(data.item.side_type){
            case 'athlete':
                return (
                    <View style={{ margin:4 }}>
                        <AthleteEventCard
                            navigation={navigation} 
                            hide_event_info 
                            hide_stat
                            athlete_id={data.item.side_id}
                            event_id={event_id} 
                            event_type='team' 
                            source={'market'}
                            market_override={active_market}
                            //do_not_load_athlete
                        />
                    </View>
                )
            case 'team':
                if(active_market.level == 'event'){
                    return (
                        <View style={{ margin:4 }}>
                            <EventMarketCard
                                event_id={event_id}
                                navigation={navigation}
                                source='market'
                                hide_market_headers
                                market_override={active_market}
                                hide_event_header
                            />
                        </View>
                    )
                }
            case 'side':
                //if(active_market.level == 'event'){
                    return (
                        <View style={{ margin:4 }}>
                            <EventMarketCard
                                event_id={event_id}
                                navigation={navigation}
                                source='market'
                                hide_market_headers
                                market_override={active_market}
                                hide_event_header
                            />
                        </View>
                    )
                //}
               //return <></>
            case 'exotic':
                return (
                    <View style={{ margin:4 }}>
                        <ExoticMarketCard
                            event_id={event_id}
                            event_type={'team'}
                            exotic_id={data.item.side_id}
                            source='market'
                            hide_event_info
                            market_override={active_market}
                            navigation={navigation}
                        />
                    </View>
                )
            default: return <></>
        }
       
    }

    /*
    if(active_market?.market_id == '13'){
        console.log(visible_order_stats)
    }
*/

    const renderMarkets = (data: { item:MarketProps, index:number }) => {
        return (
            <TouchableOpacity style={{ padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }} onPress={() => {
                setActiveMarket(data.item)
                setMarketSelectVisible(false);
            }}>
                <Text size={12} color={Colors.brand.electric}>{data.item.stat_label}</Text>
            </TouchableOpacity>
        )
    }


    return (
        <View>
            <View style={{ flexDirection:'row'}}>
                <TouchableOpacity style={{ flex:1, padding:3, paddingLeft:10, flexDirection:'row', alignItems:'center' }} onPress={() => onMarketDetails()}>
                    <View style={{ padding:7, borderRadius:100, backgroundColor:Colors.shades.shade600 }}>
                        <Icon name='bar-chart' type='feather' color={Colors.brand.electric} size={16} />
                    </View>
                    <View style={{ flex:1, padding:7 }}>
                        <Text size={12} color={Colors.brand.midnight}>Liquidity</Text>
                        <Text size={12} color={Colors.brand.electric} weight='bold'>${open_order_amount.toFixed()} • {open_order_count} Open Orders</Text>
                    </View> 
                </TouchableOpacity>
                {non_primary_markets.length > 0 && !market_override ?
                <TouchableOpacity style={{ borderLeftWidth:1, borderLeftColor:Colors.shades.shade600, justifyContent:'center', alignItems:'center', borderBottomRightRadius:expanded?0:12, paddingRight:5, paddingLeft:5 }}
                onPress={() => handleExpand()}>
                    <Text size={12} color={Colors.brand.electric} weight='semibold'>{expanded?'Hide':'More'} Markets</Text>
                    <Icon name={expanded?'chevron-up':'chevron-down'} color={Colors.brand.electric} type='feather' size={14} />
                </TouchableOpacity>  
                :   
                <></>}                 
            </View>
            {expanded ?
            <View nativeID='non-primary-markets' style={{ backgroundColor:Colors.shades.white, borderTopColor:Colors.shades.shade600, borderTopWidth:1 }}>
                <View nativeID='market_selector' style={{ padding:10, paddingLeft:20, flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.shade100 }}>
                    <View style={{ borderRadius:4, borderWidth:1, borderColor:Colors.brand.electric, padding:10 }}>
                        <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => setMarketSelectVisible(!market_select_visible)}>
                            <Text style={{ marginRight:4 }} size={12} color={Colors.brand.electric} weight='semibold'>{active_market?active_market.stat_label:'Select Market'}</Text>
                            <Icon name='chevron-down' color={Colors.brand.electric} type='feather' size={14} />
                        </TouchableOpacity>
                        {market_select_visible ?
                        <FlatList
                            data={markets}
                            renderItem={renderMarkets}
                            keyExtractor={(item) => item.market_id.toString()}
                        />
                        :<></>}
                    </View>
                    <View style={{flex:1}} />
                    <TouchableOpacity style={{ margin:5, padding:10, backgroundColor:Colors.utility.success, borderRadius:8 }} onPress={() => {
                        navigation.push('AdditionalMarkets', { event_id: event_id })
                    }}>
                        <Text size={14} color={Colors.shades.white} weight='bold' textAlign='center'>Create New Market</Text>
                    </TouchableOpacity>
                </View>
                <View nativeID='markets' style={{ padding:10 }}>
                    <FlatList
                        data={visible_order_stats}
                        renderItem={renderOrderStats}
                        keyExtractor={(item, index) => `${item.side_id}:${index}`}
                    />
                </View>
            </View>
            :<></>}
        </View>
    )
}

export default NonPrimaryMarketCard